export const filterMode = {
  'explore': 'icon-explore',
  'chart': 'icon-chart',
  'chart-area': 'icon-chart-bar',
  'stat': 'icon-table',
  'report': 'icon-grid',
  'reports': 'icon-reports',
  'tree': 'icon-flow-split',
  'radar': 'icon-radar',
  'summ-stat': 'icon-summ',
  'event-river': 'icon-river',
};

export const listMode = {
  'table': 'icon-table',
  'brief': 'icon-th-list',
  'thumblist': 'icon-file-image',
  'chat-viewer': 'icon-mail', 
};

export const typeIcons = {
  'folder': 'icon-folder-open-empty',
  'policy': 'icon-hammer',
  'uncategorized': 'icon-hammer',
  'ocrparser': 'icon-doc-text',
  'sessionprocessfilter': 'icon-reports',
  'syslogprocessfilter': 'icon-temperatire',
  'extractextprocessfilter': 'icon-file-pdf',
  'dashboard': 'icon-vcard',
  'corpusprocessfilter': 'icon-search',
  'dimensioncardfilter': 'icon-stat',
  'backupfilter': 'icon-content-broken',
  'filearchivefilter': 'icon-file-archive',
  'lateagentfilter': 'icon-attention',
  'inactiveagentfilter': 'icon-attention',
  'lateuploadfilter': 'icon-attention',
  'letteryourself': 'icon-hammer',
  'contactconnect': 'icon-chat',
  'mailgrabber': 'icon-mail',
  'filteraggregatealertfilter': 'icon-attention',
  'msgraphgrabber': 'icon-globe',
  'graphicobjectsdetector': 'icon-file-image',
  'facedetector':' icon-emo-happy',
};

export const getFilterIcon = filter => {
  const icon = typeIcons[filter.content_type];
  if (icon) return icon;
  if (filter.mode == 'explore') return listMode[filter.listType];
  if (filter.isGraph) return 'icon-share';
  return filterMode[filter.mode] ? filterMode[filter.mode] : 'icon-wrench';
};



// WEBPACK FOOTER //
// ./src/common/filter-mode.js